export enum ThemeColor {
  Primary = 'primary',
  Warn = 'warn',
  Accent = 'accent',
}
